import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "logo" }
const _hoisted_2 = { class: "logo__icon" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-coins" }, null, -1)
const _hoisted_4 = { class: "logo__name" }
const _hoisted_5 = { class: "navigation__wrapper" }
const _hoisted_6 = { class: "navigation__linkName" }
const _hoisted_7 = { class: "navigation__tooltip" }

import { computed } from "vue";
import { useAppStore } from "@/store/app";
import { useAuthStore } from "@/store/auth";
import { useLangStore } from "@/store/lang";
import { useMenuStore } from "@/store/menu";

// import { menuItems } from "@/config/menuItems";
import { ItemVisibility } from "@/types/menuTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheMenu',
  setup(__props) {

const appStore = useAppStore();
const authStore = useAuthStore();
const langStore = useLangStore();
const menuStore = useMenuStore();

const messages = computed(() => {
  return langStore.messages.menu;
});

const menuVisibleItems = computed(() => {
  return menuStore.menuItems.filter((item) => {
    const isAlwaysVisible = item.visible === ItemVisibility.always;
    const forAuthenticated =
      item.visible === ItemVisibility.auth && authStore.isAuthenticated;
    const forUnauthenticated =
      item.visible === ItemVisibility.unauth && !authStore.isAuthenticated;

    if (isAlwaysVisible || forAuthenticated || forUnauthenticated) return true;
    return false;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navigation", { 'navigation--active': _unref(appStore).isMenuActive }])
  }, [
    _createElementVNode("figure", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("figcaption", _hoisted_4, _toDisplayString(_unref(messages).logo), 1)
      ])
    ]),
    _createElementVNode("i", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(appStore).toogleMenu && _unref(appStore).toogleMenu(...args))),
      class: _normalizeClass(["fa-solid navigation__hamburger", _unref(appStore).isMenuActive ? 'fa-x' : 'fa-bars']),
      id: "btn"
    }, null, 2),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuVisibleItems), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "navigation__item",
          key: item.name
        }, [
          _createVNode(_component_router_link, {
            class: "navigation__link",
            to: { name: item.href }
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass([item.icon, "icon"])
              }, null, 2),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1)
        ]))
      }), 128))
    ])
  ], 2))
}
}

})